import { useCallback, useEffect, useState, } from 'react';
const mouseButtons = [
    'left',
    'middle',
    'right',
    'back',
    'forward',
];
const usePointerClick = (callback) => {
    const [eventMetaData, setEventMetaData,] = useState(null);
    const onPointerClick = (useCallback(({ pointerId, target, }) => {
        setEventMetaData({
            pointerId,
            target,
        });
    }, [
        setEventMetaData,
    ]));
    useEffect(() => {
        if (!eventMetaData) {
            return () => { };
        }
        const onPointerClickUp = (event) => {
            if (event.pointerType === 'mouse'
                && mouseButtons[event.button] !== 'left'
                && mouseButtons[event.button] !== 'middle') {
                return;
            }
            if (event.target === eventMetaData.target
                && event.pointerId === eventMetaData.pointerId) {
                callback(event);
                setEventMetaData(undefined);
            }
        };
        eventMetaData
            .target
            .ownerDocument
            .defaultView
            .addEventListener('pointerup', onPointerClickUp);
        return () => {
            eventMetaData
                .target
                .ownerDocument
                .defaultView
                .removeEventListener('pointerup', onPointerClickUp);
        };
    }, [
        callback,
        eventMetaData,
        setEventMetaData,
    ]);
    return onPointerClick;
};
export default usePointerClick;
